var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-organisation-container"},[_c('div',{staticClass:"card-section-header"},[_c('h2',[_vm._v(_vm._s(_vm.$t('Add an organisation')))])]),_c('organisation-form',{attrs:{"formData":{}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }